export { IconImgUpload2 } from "./IconImgUpload2";
